import { Component, Input, OnInit } from '@angular/core';
import { BrandingState } from '../../../branding/store/branding.state';
import { AccessibilityService } from '../../../../providers/accessibility/accessibility.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'app-patients-questions',
    templateUrl: './patients-questions.component.html',
    styleUrls: ['./patients-questions.component.scss'],
    imports: [TranslatePipe]
})
export class PatientsQuestionsComponent implements OnInit {
    @Input() brandingSettings: BrandingState;

    constructor(private accessibilityService: AccessibilityService,
                private translate: TranslateService) {
    }

    ngOnInit(): void {
        // BFSG: Announce FAQ section to screen readers
        this.translate.get('ACCESSIBILITY.SR_FAQ_SECTION_LOADED').subscribe(message => {
            this.accessibilityService.announceToScreenReader(message, 'polite');
            });
    }
}
